module.exports = __webpack_public_path__ + "img/cs-box.ba19812b.png";